<div class="loading" [ngClass]="{'d-none': !loading}">
  <div class="loading_animation">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <polygon class="loading_svg"
        points="44.2 88.5 44.2 81.8 26.1 84 27.3 76.9 8.9 62.9 13 58 9.8 46.2 22.4 46.8 26.4 42 38.4 52.4 30.5 20.4 40.9 23.6 49.2 13.7 57.5 23.6 68 20.4 60.1 52.4 72 42 76 46.8 88.6 46.2 85.4 58 89.5 62.9 70.9 77.1 72 84 54.2 81.8 54.2 88.5 ">
      </polygon>
    </svg></div>
</div>